import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ActivationPreService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation pre
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getActivationPre(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_ACTIVATION_PRE, configData, config));
    }

    /**
     * Sends activation pre
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async sendActivationPre(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.SEND_ACTIVATION_PRE, configData, config));
    }

    async getActivationControle(configData: any) {
      let config = this.httpService.setHeaderConfig(true);
      return lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_ACTIVATION_CONTROLE, configData, config));
    }

    async sendActivationControle(configData: any) {
      let config = this.httpService.setHeaderConfig(true);
      return lastValueFrom(this.httpService.post(UrlConnectionEnum.SEND_ACTIVATION_CONTROLE, configData, config));
    }

    async getAllActivations(configData: any) {
      let config = this.httpService.setHeaderConfig(true);
      return lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_ALL_ACTIVATIONS, configData, config));
    }
}
